import { render, staticRenderFns } from "./FaceOverlay.vue?vue&type=template&id=92b5609e&scoped=true&"
import script from "./FaceOverlay.vue?vue&type=script&lang=js&"
export * from "./FaceOverlay.vue?vue&type=script&lang=js&"
import style0 from "./FaceOverlay.vue?vue&type=style&index=0&id=92b5609e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b5609e",
  null
  
)

export default component.exports